module.exports = __webpack_public_path__ + "static/media/bgDark.c1dc42d6.svg";